import React from 'react';
import PropTypes from 'prop-types';

const Divider = props => (
  <div
    style={{
      borderBottom: '1px solid #cecece',
      width: '100%',
      margin: '10px 0px',
      color: '#4e4e4e',
      fontSize: 16,
      fontWeight: 'bold'
    }}
  >
    {props.title}
  </div>
);

Divider.propTypes = {
  title: PropTypes.string.isRequired,
  position: PropTypes.oneOf(['left', 'center', 'right']),
};

Divider.defaultProps = {
  position: 'left',
};

export default Divider;
